import { required } from '../../../../../shared/lib/validation/validateRequired/required';
import { clearEmptyErrors } from '../../../../../shared/lib/validation/clearEmptyErrorsValidation/clear-empty-errors';
import { PasswordFormFields } from '../../ui/password-step/types';
import { PasswordFormKeys } from '../../config/form-password-constants';

export const validate = (fields: PasswordFormFields) => {
    const errors = {} as Record<PasswordFormKeys, string>;
    errors[PasswordFormKeys.Password] = required(fields[PasswordFormKeys.Password], 'Введите пароль');
    return clearEmptyErrors(errors);
};
